module.exports = __webpack_public_path__ + "static/aforgotpassword-805d1fb07352c40cda04c9550b58a938.png";